import { useCallback, useRef } from 'react';
export var useLongPress = function useLongPress(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
  var timeoutId = useRef();
  var handleLongPressStart = useCallback(function (event) {
    event.preventDefault();
    timeoutId.current = setTimeout(function () {
      callback(event);
    }, delay);
  }, [callback, delay]);
  var handleLongPressEnd = useCallback(function () {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
  }, []);
  return {
    onTouchStart: handleLongPressStart,
    onTouchEnd: handleLongPressEnd
  };
};